// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div>
        <strong>The Drone Lab at The College of Charleston</strong>
      </div>
    </footer>
  );
}

export default Footer;
